import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import MessageChat from "./MessageChat";

export default function MessageChatWrapper() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  
  const { receiverId, userName } = useParams<{
    receiverId: string;
    userName: string;
  }>();
  
  const photoId = searchParams.get('photoId') || undefined;
  const scrollToMessageId: number | undefined =
    (location.state as { scrollToMessageId?: number } | null)?.scrollToMessageId;

  if (!receiverId || !userName) {
    navigate(-1);
    return null;
  }

  return (
    <MessageChat
      onBack={() => navigate("/OverViewMessages")}
      userId={receiverId}                  
      userName={decodeURIComponent(userName)}
      userPhotoId={photoId}
      scrollToMessageId={scrollToMessageId}
    />
  );
}
